import MixpanelManager from "./MixpanelManager";

const mixpanelManager = new MixpanelManager();

export { mixpanelManager };
